import React from "react";
import styles from "./CustomHeader.module.scss";
import Button from "../Button/Button";
import SearchIcon from "../SVGComponents/SearchIcon";
import PlusIcon from "../SVGComponents/PlusIcon";
import FilterIcon from "../SVGComponents/FilterIcon";

interface CustomHeaderProps {
  search?: string | null;
  setSearch?: React.Dispatch<React.SetStateAction<string | null>>;
  buttonLabel?: string;
  onButtonClick?: () => void;
  filter?: boolean;
}
const CustomHeader: React.FC<CustomHeaderProps> = ({
  search,
  setSearch,
  buttonLabel,
  onButtonClick,
  filter = false,
}) => {
  const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch?.(e.target.value);
  };

  return (
    <div className={styles.topSection}>
      <div className={styles.filterSearch}>
        <span className={styles.search}>
          <SearchIcon className={styles.searchIcon} />
          <input
            value={search ?? ""}
            onChange={onSearchChange}
            type="text"
            placeholder="Search"
          />
        </span>
        {filter && (
          <span className={styles.filter}>
            <FilterIcon />
          </span>
        )}
      </div>
      {onButtonClick && (
        <Button
          onClick={onButtonClick}
          className={styles.button}
          outlined={false}
        >
          {buttonLabel}
        </Button>
      )}
    </div>
  );
};

export default CustomHeader;
